module.exports = __webpack_public_path__ + "img/title-HIWmg-m.8ea386a6.png";